module.exports = __webpack_public_path__ + "img/icon-szyw.1ec92145.png";